import router from '@this/router';
import { isAlipay } from '@/utils/browser';

const state = {};

const mutations = {};

const actions = {
  // 事件
  gotoIndex() {
    router.push('/index');
  },
  gotoGame() {
    router.push('/game');
  },
  gotoMy() {
    router.push('/my');
  },
  gotoRule() {
    router.push('/rule');
  },
  gotoView(context, id) {
    router.push({
      path: '/view',
      query: {
        id: id,
      },
    });
  },
  gotoShare() {
    const link = `${window.location.origin}${process.env.VUE_APP_BASE_URL}/share`;
    if (isAlipay) {
      ap.pushWindow(link);
    } else {
      window.location.href = link;
    }
  },
  gotoLink(context, link) {
    if (isAlipay) {
      ap.pushWindow(link);
    } else {
      window.location.href = link;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
